module.exports = __webpack_public_path__ + "static/img/correctBanner.6fdc21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/correctBanner.png
// module id = SYKL
// module chunks = 1